import React from 'react';
import mission from './Our Mission.png';
import vision from './vision.png';
import './vision_and_mission.css';

function VisionMission() {
  return (
    <div id="Intro-container">
      <div id="vision-section">
        <div className="col" id="our-vision-content">
          <p id="our-vision-title">Our Vision</p>
          <p id="our-vision-text">
            Empowering India's Future Through Science, Education, Technologies and Leadership in
            Nuclear Energy, fostering informed dialogue, innovative solutions, and inclusive growth
            towards a sustainable and energy-secure nation.
          </p>
        </div>
        <div className="col" id="vision-img">
          <img alt="vision" src={vision}></img>
        </div>
      </div>
      <div className="row" id="mission-section">
        <div className="col" id="mission-img">
          <img alt="mission" src={mission}></img>
        </div>
        <div className="col" id="our-mission-content">
          <div>
            <p id="our-mission-title">Our Mission</p>
            <p id="our-mission-text">
              To ignite passion and empower the youth of India with knowledge, skills, and
              leadership in nuclear science and technology; to foster a vibrant community dedicated
              to advancing safe, sustainable, and innovative nuclear solutions; and to actively
              contribute to shaping national and global nuclear policy through education, outreach,
              advocacy, research, and collaboration.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VisionMission;
